import apiClient from '../apiClient';
import { PUT_AREA_URL } from '../apiUrl';

const putAreaApi = (id, data) => {
  return apiClient.put(PUT_AREA_URL(id), data);
};

export default putAreaApi;
